export default function avatarFromUrl(url) {
  try {
    const parsedUrl = new URL(url).hostname;
    return `https://unavatar.now.sh/${parsedUrl}`;
  } catch {
    return null;
  }
}
